import createReactComponent from '../createReactComponent';
export default createReactComponent('alarm-average', 'IconAlarmAverage', [
  ['path', { d: 'M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0', key: 'svg-0' }],
  ['path', { d: 'M7 4l-2.75 2', key: 'svg-1' }],
  ['path', { d: 'M17 4l2.75 2', key: 'svg-2' }],
  ['path', { d: 'M8 13h1l2 3l2 -6l2 3h1', key: 'svg-3' }],
]);
